
import styles from "./ContactSection.module.css";
import commonStyles from "components/commonStyle/commonStyle.module.css";


export default function ContactSection() {

    return (
        <div className={`${commonStyles.sectionContainer} ${styles.container}`}>
            <div className={`${commonStyles.sectionTitle} ${styles.kontaktTitle}`}>
                <h1>Kontakt</h1>
                <div className={`${commonStyles.sectionBorderBottom} ${styles.borderBottom}`} />
            </div>
            <div className={styles.contentContainer}>
                <div className={styles.leftSection}>
                    <p>
                        Sollten noch Fragen  offen sein, ruf uns einfach an.
                        <br />
                        Wir  informieren  Dich gerne über weitere Details zur Flexi.
                    </p>
                </div>

                <div className={styles.rightSection}>
                    <div className={styles.infoRow}>
                        <label className={styles.label}>Adresse</label>
                        <p className={styles.info}>Adolf-Reichwein-Straße 25, 57076 Siegen</p>
                    </div>
                    <div className={styles.infoRow}>
                        <label className={styles.label}>Telefonnummer</label>
                        <p className={styles.info}>0271 740 - 4079</p>
                    </div>
                    <div className={styles.infoRow}>
                        <label className={styles.label}>E-Mail</label>
                        <p className={styles.info}>flexi@studierendenwerk.uni-siegen.de</p>
                    </div>
                </div>
            </div>
        </div>
    );
}